_is_within_range